module.exports = __webpack_public_path__ + "media/images/e-bilet/info_i-0b920dc958ef8184580313a3d7d1dc38.svg";